require('./bootstrap');
import { FerryKinectDispatchApp } from './ferrykinect.dispatch.js';
window.FerryKinectDispatchApp = FerryKinectDispatchApp;
